export default __webpack_public_path__ + "static/honesty-02567347c611fc277a480c902c8ad86f.png";